import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box, CircularProgress, Alert, Button, Divider } from '@mui/material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const PatientAppointmentDetails = () => {
  const { id } = useParams();
  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchAppointment = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await axios.get(`${API_URL}/api/patients/me/appointments/${id}`);
        setAppointment(res.data);
      } catch (err) {
        setError('Failed to load appointment');
      } finally {
        setLoading(false);
      }
    };
    fetchAppointment();
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>;
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!appointment) return null;

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>Appointment Details</Typography>
      <Box sx={{ mb: 2 }}>
        <Typography><strong>Date & Time:</strong> {new Date(appointment.appointmentTime).toLocaleString()}</Typography>
        <Typography><strong>Status:</strong> {appointment.status}</Typography>
        <Typography><strong>Notes:</strong> {appointment.notes || 'None'}</Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6">Tests</Typography>
        {appointment.tests.map((test, idx) => (
          <Typography key={idx}>• {test.name}</Typography>
        ))}
      </Box>
      <Button variant="outlined" onClick={handlePrint}>Print</Button>
    </Container>
  );
};

export default PatientAppointmentDetails; 